module.exports = __webpack_public_path__ + "img/nextdoorcam-logo.be695a63.png";